module.exports = __webpack_public_path__ + "img/map.f820f748.svg";